module.exports = __webpack_public_path__ + "static/glidden-781cc98191a8ab7c80c01e579ca84e9b.jpg";